import { postRequest } from "../httpMethods";

export const postCourseReview = (payload) =>
    postRequest(`reviews`, payload);
